"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Spinner = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var Spinner = _styledComponents["default"].div.withConfig({
  displayName: "Spinnerstyles__Spinner",
  componentId: "sc-19a3pxi-0"
})(["@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}.spinner__visual{animation:spin 1.2s infinite linear;border-color:rgba(0,0,0,0.1);border-left-color:", ";border-radius:50%;border-style:solid;margin-left:auto;margin-right:auto;overflow:hidden;}&.spinner--small .spinner__visual{border-width:2px;height:", ";width:", ";}&.spinner--medium .spinner__visual{border-width:3px;height:", ";width:", ";}&.spinner--large .spinner__visual{border-width:4px;height:", ";width:", ";}.spinner__caption{", " ", " color:", ";font-weight:normal;margin:", " auto 0 auto;overflow:hidden;text-align:center;}&.spinner--small .spinner__caption{", ";max-width:210px;}&.spinner--medium .spinner__caption{", ";max-width:240px;}&.spinner--large .spinner__caption{", ";max-width:270px;}.spinner__aria-alert{", "}"], _tokens["default"].color.purple, _stylers["default"].spacer(3), _stylers["default"].spacer(3), _stylers["default"].spacer(6), _stylers["default"].spacer(6), _stylers["default"].spacer(9), _stylers["default"].spacer(9), _stylers["default"].lineHeight(-2), _stylers["default"].truncateText, _tokens["default"].color.blackLighten20, _tokens["default"].space, _stylers["default"].fontSize(-3), _stylers["default"].fontSize(-1), _stylers["default"].fontSize(), _stylers["default"].visuallyHidden);

exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.styles.js.map